module.exports = __webpack_public_path__ + "static/media/play.61e552ad.svg";